<div class="articles-list-wrapper" (click)="bgClick()">
  <ng-container *ngIf="loading; else Content">
    <div class="loading-wrapper" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner [diameter]="40" [strokeWidth]="4" [attr.aria-hidden]="true"> </mat-spinner>
    </div>
  </ng-container>

  <ng-template #Content>
    <div class="articles-list">
      <div *ngIf="!articles?.length" class="empty-list-info">
        <nz-empty></nz-empty>
      </div>

      <div *ngFor="let article of articles" class="article-item-wrapper">
        <app-article-list-item [article]="article"></app-article-list-item>
      </div>
    </div>
  </ng-template>
</div>
